import { usePageBranding } from '@/hooks/usePageBranding';

interface BrandingInitializerProps {
  children: React.ReactNode;
}

/**
 * Initializes page branding (title, favicon) from company settings
 * Should be placed inside QueryClientProvider
 */
export function BrandingInitializer({ children }: BrandingInitializerProps) {
  usePageBranding();
  return <>{children}</>;
}
